import React from "react";

function Footer() {
  return (
    <div className="footer">
      <h4 className="footer_copy">© Buildr 2021</h4>
    </div>
  );
}

export default Footer;
